export default {
  createANewRepair: "Crear un nuevo registro de reparación",
  equipmentTag: "Tag del Activo",
  createdBy: "Creado por",
  log: "Registro",
  submit: "Crear"
};
